import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-assessment-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './assessment-layout.component.html',
})
export class AssessmentLayoutComponent {}